import { render, staticRenderFns } from "./NsSearchResults.vue?vue&type=template&id=972b680a&scoped=true&"
import script from "./NsSearchResults.vue?vue&type=script&lang=js&"
export * from "./NsSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./NsSearchResults.vue?vue&type=style&index=0&id=972b680a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972b680a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('972b680a')) {
      api.createRecord('972b680a', component.options)
    } else {
      api.reload('972b680a', component.options)
    }
    module.hot.accept("./NsSearchResults.vue?vue&type=template&id=972b680a&scoped=true&", function () {
      api.rerender('972b680a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsSearchResults.vue"
export default component.exports